import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from "rxjs";
import { UserModel } from "src/app/shared/models/usuarios/user.model";
import { environment } from "src/environments/environment";
import {
    SwitchApp,
    SwitchAppItem,
} from "src/app/shared/models/enum/switchApp.model";

import { TaxisLineaModel } from "src/app/shared/models/taxis/taxis.model";
import { ServicioModel } from "src/app/shared/models/servicios/servicios.model";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { SubProcesosService } from 'src/app/core/services/sub-procesos.service';

@Injectable({ providedIn: "root" })
export class AuthenticationService {
    private nameSession: string = "us-conduc-planner";
    nameSessionApp: string = "switchapp";

    public currentUserSubject: BehaviorSubject<UserModel>;
    public currentUser: Observable<UserModel>;

    public currentTaxiService: BehaviorSubject<TaxisLineaModel> =
        new BehaviorSubject(null);
    public currentconductoresService: BehaviorSubject<ServicioModel> =
        new BehaviorSubject(null);

    get urlBase(): string {
        return `${environment.apiTrafico}`;
    }
    get urlTrafico(): string {
        return `${environment.apiTrafico}`;
    }

    get urlVTC(): string {
        return this.currentDns?.toLowerCase() != "demo"
            ? `${environment.apiVTC}`
            : environment.apiVTC;
    }

    get urlTaller(): string {
        return `${environment.apiTaller}`;
    }

    get urlSgRegulares(): string {
        return `${this.urlTrafico}`;
    }

    get urlRegulares(): string {
        return `${this.urlTrafico}`;
    }

    get urlSAE(): string {
        return `${environment.apiTrafico}`;
    }

    get urlTAD(): string {
        var dns = this.dnsSubject.value;
        return `https://${dns}${environment.apiTAD}`;
    }

    get urlComms(): string {
        return `${environment.apiMensajeria}api/`;
    }

    get urlSgComms(): string {
        return `${environment.apiMensajeria}`;
    }

    dnsSubject: BehaviorSubject<string> = new BehaviorSubject<string>(
        localStorage.getItem("dns")
    );
    get currentDns(): string {
        return this.dnsSubject.value;
    }

    constructor(private http : HttpClient) {        
        this.currentUserSubject = new BehaviorSubject<UserModel>(
            localStorage.getItem(this.nameSession)
                ? JSON.parse(atob(localStorage.getItem(this.nameSession)))
                : null
        );
        this.currentUser = this.currentUserSubject.asObservable();
    }

    /**
     *
     *
     * @readonly
     * @type {User}
     * @memberof AuthenticationService
     */
    public get currentUserValue(): UserModel {
        return this.currentUserSubject.value;
    }

    public get getIdMsMensaria(): string {
        return this.currentUserValue._id;
    }

    /**
     *
     *
     * @readonly
     * @type {String}
     * @memberof AuthenticationService
     */
    public get getToken(): string {
        return "";
        // return this.currentUserSubject.value.token;
    }

    /**
     * @summary Elimina el usuario de sessionStorage y el currentUserSubject pasa a a ser null.
     * @memberof AuthenticationService
     */
    logout() {
        this.removeSession();
        this.currentUserSubject.next(null);
        this.dnsSubject.next(null);      
    }

    setDns(empresa: string) {
        localStorage.setItem("dns", empresa);
        this.dnsSubject.next(empresa);
    }

    // guardarCurrentUser(usuario: UserModel) {
    //     //this.currentUserSubject.next(usuario); // Esto estaba en comentario y hace que la aplicación no funciona para obtener la información del usuario.
    //     sessionStorage.setItem(this.nameSession, btoa(JSON.stringify(usuario)));
    //     this.currentUserSubject.next(usuario);
    // }

    

    guardarCurrentUser(usuarioParcial: Partial<UserModel>) {
        const usuarioActual = this.currentUserValue || {};
        const usuarioFinal = {
            ...usuarioActual,
            ...usuarioParcial,
        };

        localStorage.setItem(
            this.nameSession,
            btoa(JSON.stringify(usuarioFinal))
        );
        this.currentUserSubject.next(usuarioFinal as UserModel);
    }

    setNewconductoresServiceActive(data: ServicioModel) {
        this.currentconductoresService.next(data);
    }

    setNewTaxiServiceActive(data: TaxisLineaModel) {
        this.currentTaxiService.next(data);
    }

    //taxis
    guardarAuthTaxis(vehiculo, matricula) {
        var user = this.currentUserValue;
        if (user) {
            user.loginTaxis = {
                matricula: matricula,
                vehiculo: vehiculo,
            };
            this.guardarCurrentUser(user);
            localStorage.setItem(
                this.nameSession,
                btoa(JSON.stringify(user))
            );
        } else {
            var newUser: UserModel = {
                loginTaxis: {
                    vehiculo: vehiculo,
                    matricula: matricula,
                },
                activeVehicle: [],
            };
            this.guardarCurrentUser(newUser);
            localStorage.setItem(
                this.nameSession,
                btoa(JSON.stringify(newUser))
            );
        }
    }

    //SwitchApp: la app permite cambiar entra las apps en la clase SwitchApp.
    getSessionSwitchApp() {
        return SwitchApp[localStorage.getItem(this.nameSessionApp)];
    }

    setSessionSwitchApp(app: SwitchAppItem) {
        if (app) {
            localStorage.setItem(this.nameSessionApp, app.text);
        }
    }

    removeSession() {
        localStorage.clear();
    }

    //#region jwt

    get getDecodeJwt(): JwtPayload {
        return jwtDecode(this.currentUserValue.tokenTrafico);
    }

    setJwt(jwt) {
        var user = this.currentUserValue;
        user.tokenTrafico = jwt;
        this.guardarCurrentUser(user);
    }

    //#endregion
}
